// src/components/HeaderSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function BlogPreview({ blogs }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
      {blogs.map((blog, index) => (
        <motion.div
          key={index}
          className="border-2 border-gray-300 rounded-lg backdrop-blur-sm bg-black/30 overflow-hidden hover:scale-105 transition duration-300 flex flex-col"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.2 }}
        >
          <img
            src={blog.image}
            alt={blog.title}
            className="w-full h-56 object-cover shadow-lg"
          />
          <div className="p-6 flex flex-col gap-3 text-gray-200">
            <p className="text-grayText text-sm">{blog.date}</p>
            <h3 className="text-white font-bold text-xl">{blog.title}</h3>
            <p className="text-grayText text-base">
              {blog.preview}{" "}
              <Link
                to={blog.link}
                className="text-neonTurquoise font-bold hover:underline"
              >
                Read More
              </Link>
            </p>
            <p className="mt-2 text-sm">
              📌 {blog.keywords.join(", ")}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
